import { Theme } from '@mui/material/styles';

import { theme as staticTheme } from '../../theme';

export const borderStyle = `1px solid ${staticTheme.colors.border.menuButton}`;

export const surroundingBottomBorders = {
  borderLeft: borderStyle,
  borderBottom: borderStyle,
  borderRight: borderStyle,
};

export const curveTheBottomBorder = {
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
};

export const openTheBottomBorder = {
  borderBottom: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
};

export const suppressHoverBackground = { background: 'inherit !important' };

export const removeBorderAndOutline = {
  '& .MuiDataGrid-cell': {
    borderBottom: 0,
    borderTop: 0,
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'inherit',
  },
};

export const mainGridStyling = (theme: Theme) => ({
  border: 0,
  '& .MuiDataGrid-groupingCriteriaCell': {
    height: '100%',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'inherit',
  },
  '--unstable_DataGrid-headWeight': theme.typography.fontWeightRegular,
  '& .MuiDataGrid-columnHeaders': {
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    border: borderStyle,
    marginBottom: theme.spacing(4),
    paddingLeft: 6,
    paddingRight: 6,
  },
});

export const childRowStyling = () => ({
  ...suppressHoverBackground,
  width: '99.7%',
  '& .MuiDataGrid-cell': {
    border: 0,
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'inherit',
  },
  ...surroundingBottomBorders,
  '&.MuiDataGrid-row--detailPanelExpanded': openTheBottomBorder,
  '&:has(+ .parent-group-row), &:last-of-type': {
    ...curveTheBottomBorder,
    '&.MuiDataGrid-row--detailPanelExpanded': openTheBottomBorder,
  },
});

export const detailPanelStyling = (theme: Theme) => ({
  '& .MuiDataGrid-detailPanel': {
    width: '99.89%',
    backgroundColor: 'inherit',
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    ...surroundingBottomBorders,
    ...curveTheBottomBorder,
  },
  '.MuiDataGrid-row--detailPanelExpanded': {
    '& .expand-child-button': {
      transform: 'rotate(90deg)',
    },
  },
});

export const subParentGroupStyling = (theme: Theme) => ({
  cursor: 'pointer',
  color: theme.text.placeholder,
  ...suppressHoverBackground,
  ...surroundingBottomBorders,
  ...removeBorderAndOutline,
  width: '99.7%',
  '& .MuiDataGrid-groupingCriteriaCellToggle': {
    margin: 0,
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(0.25),
    paddingTop: theme.spacing(0.25),
  },
  '&:has(+ .parent-group-row), &:last-of-type': curveTheBottomBorder,
  '& .sub-parent-group-header-cell': {
    textTransform: 'uppercase',
    paddingLeft: 0,
  },
});

export const parentGroupStyling = (theme: Theme) => ({
  cursor: 'pointer',
  borderRadius: 12,
  border: borderStyle,
  background: `${theme.background.surfaceLight} !important`,
  boxShadow: theme.custom?.softNavyShadow,
  ...removeBorderAndOutline,
  width: '99.7%',
  '& .parent-group-header-cell': {
    overflow: 'visible !important',
    '& .MuiDataGrid-groupingCriteriaCellToggle': { display: 'none' },
  },
});
